<template>
	<div class="three60-interaction-popup">
		<div class="popup-body">
			<svg
				class="close-button"
				width="14"
				height="14"
				viewBox="0 0 14 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12.8966 1L1 12.7931"
					stroke="white"
					stroke-width="0.835088"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M13.0001 13L1.20703 1.10345"
					stroke="white"
					stroke-width="0.835088"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</svg>
			<svg
				class="background-svg"
				xmlns="http://www.w3.org/2000/svg"
				width="128"
				height="98"
				viewBox="0 0 128 98"
				fill="none"
			>
				<g opacity="0.8" filter="url(#filter0_b_1_15)">
					<rect
						width="128"
						height="98"
						rx="12"
						fill="black"
						fill-opacity="0.4"
					/>
				</g>
				<!-- <path
					d="M119 15L115.571 11.5709L113 9"
					stroke="#DDDDDD"
					stroke-linecap="round"
				/> -->
				<!-- <path
					d="M113 15L116.429 11.5709L119 9"
					stroke="#DDDDDD"
					stroke-linecap="round"
				/> -->
				<defs>
					<filter
						id="filter0_b_1_15"
						x="-4"
						y="-4"
						width="136"
						height="106"
						filterUnits="userSpaceOnUse"
						color-interpolation-filters="sRGB"
					>
						<feFlood
							flood-opacity="0"
							result="BackgroundImageFix"
						/>
						<feGaussianBlur
							in="BackgroundImageFix"
							stdDeviation="2"
						/>
						<feComposite
							in2="SourceAlpha"
							operator="in"
							result="effect1_backgroundBlur_1_15"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_backgroundBlur_1_15"
							result="shape"
						/>
					</filter>
				</defs>
			</svg>
			<svg
				class="three60-svg"
				width="65"
				height="43"
				viewBox="0 0 65 43"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M37.2008 30.3553C36.7851 29.1562 36.8708 27.8437 37.4391 26.7066C38.0073 25.5696 39.0116 24.7011 40.231 24.2923C41.4504 23.8834 42.785 23.9677 43.9412 24.5266C45.0974 25.0854 45.9805 26.0731 46.3962 27.2723C46.4392 27.3963 46.4303 27.5321 46.3715 27.6497C46.3128 27.7674 46.2089 27.8572 46.0827 27.8995C45.9566 27.9418 45.8185 27.9331 45.6989 27.8752C45.5793 27.8174 45.4879 27.7153 45.4449 27.5912C45.1152 26.6401 44.4148 25.8568 43.4979 25.4136C42.5809 24.9703 41.5224 24.9035 40.5553 25.2278C39.5882 25.552 38.7917 26.2408 38.341 27.1426C37.8903 28.0444 37.8224 29.0853 38.1521 30.0364C38.1951 30.1605 38.1862 30.2962 38.1274 30.4139C38.0686 30.5315 37.9647 30.6213 37.8386 30.6636C37.7125 30.7059 37.5744 30.6972 37.4548 30.6394C37.3352 30.5816 37.2438 30.4794 37.2008 30.3553ZM49.3833 30.2736C48.9706 30.4115 48.6099 30.6687 48.3481 31.0114C48.1669 30.7157 47.9156 30.4674 47.6157 30.2878C47.3158 30.1082 46.9762 30.0026 46.6258 29.98C46.2754 29.9574 45.9247 30.0184 45.6035 30.1579C45.2823 30.2974 45.0001 30.5112 44.7811 30.7811L43.8595 28.1228C43.6732 27.5852 43.2773 27.1425 42.759 26.8919C42.2407 26.6414 41.6425 26.6036 41.0958 26.7869C40.5492 26.9702 40.099 27.3595 39.8443 27.8692C39.5895 28.3789 39.5511 28.9673 39.7375 29.5048L42.0887 36.2872L41.1648 35.544C40.7289 35.1709 40.16 34.9834 39.5835 35.0227C39.007 35.0621 38.47 35.325 38.0906 35.7537C37.7112 36.1825 37.5205 36.7419 37.5605 37.3088C37.6005 37.8758 37.8679 38.404 38.3038 38.7771L41.9793 41.8957C42.0804 41.9775 42.21 42.0174 42.3405 42.0067C42.471 41.996 42.5921 41.9356 42.678 41.8384C42.7639 41.7412 42.8078 41.6148 42.8004 41.4863C42.793 41.3577 42.7349 41.237 42.6384 41.15L38.9653 38.0306C38.8494 37.9309 38.7546 37.8097 38.6863 37.674C38.618 37.5382 38.5776 37.3906 38.5673 37.2395C38.5466 36.9344 38.6499 36.6336 38.8547 36.4034C39.0594 36.1732 39.3487 36.0324 39.659 36.012C39.8127 36.0019 39.9668 36.0217 40.1127 36.0702C40.2586 36.1187 40.3933 36.1949 40.5092 36.2946C40.513 36.2986 40.5172 36.3021 40.5217 36.3052L42.8133 38.1475C42.8978 38.2157 43.0026 38.255 43.1119 38.2593C43.2211 38.2637 43.3288 38.2328 43.4187 38.1715C43.5085 38.1102 43.5755 38.0217 43.6096 37.9196C43.6437 37.8174 43.643 37.7071 43.6075 37.6053L40.6887 29.1859C40.5884 28.8964 40.6091 28.5796 40.7462 28.3052C40.8834 28.0307 41.1258 27.8211 41.4201 27.7224C41.7145 27.6237 42.0366 27.6441 42.3157 27.779C42.5948 27.9139 42.8079 28.1523 42.9083 28.4417L44.746 33.7428C44.7891 33.8669 44.8804 33.9691 45 34.0269C45.1196 34.0847 45.2577 34.0934 45.3838 34.0511C45.51 34.0088 45.6139 33.919 45.6726 33.8014C45.7314 33.6837 45.7403 33.548 45.6973 33.4239L45.373 32.4884C45.2726 32.1989 45.2933 31.8821 45.4305 31.6077C45.5677 31.3332 45.8101 31.1236 46.1044 31.0249C46.3987 30.9262 46.7209 30.9466 47 31.0815C47.279 31.2164 47.4922 31.4548 47.5926 31.7442L48.1331 33.3034C48.1761 33.4274 48.2674 33.5296 48.387 33.5874C48.5066 33.6452 48.6447 33.6539 48.7708 33.6116C48.897 33.5694 49.0009 33.4795 49.0597 33.3619C49.1185 33.2443 49.1273 33.1085 49.0843 32.9844L48.9762 32.6726C48.8759 32.3831 48.8965 32.0663 49.0337 31.7919C49.1709 31.5174 49.4133 31.3078 49.7076 31.2091C50.002 31.1104 50.3241 31.1308 50.6032 31.2657C50.8823 31.4006 51.0954 31.639 51.1958 31.9284L52.1687 34.7349C52.7668 36.4601 52.5948 37.8274 52.5931 37.8402C52.5763 37.9693 52.612 38.0997 52.6924 38.203C52.7728 38.3064 52.8914 38.3744 53.0225 38.3923C53.0998 38.4045 53.179 38.3983 53.2533 38.3741C53.3419 38.3446 53.4204 38.2913 53.4799 38.2203C53.5394 38.1494 53.5776 38.0635 53.5901 37.9723C53.5989 37.9084 53.7999 36.3748 53.1207 34.4157L52.1478 31.6092C52.0555 31.343 51.9108 31.0972 51.7219 30.886C51.533 30.6748 51.3036 30.5022 51.0469 30.3782C50.7902 30.2542 50.5111 30.1811 50.2257 30.1631C49.9403 30.1452 49.654 30.1827 49.3833 30.2736Z"
					fill="white"
				/>
				<path
					d="M12.3212 22.3911L9.63107 24.1501C9.51779 24.224 9.4203 24.3195 9.34422 24.4311C9.26814 24.5426 9.21497 24.6681 9.18778 24.8002C9.16058 24.9324 9.15989 25.0685 9.18574 25.2009C9.2116 25.3333 9.2635 25.4593 9.33844 25.5716C9.48905 25.7973 9.72338 25.9541 9.99 26.0078C10.2566 26.0615 10.5337 26.0076 10.7605 25.858L15.4785 22.7899C15.7059 22.6407 15.8644 22.4077 15.9193 22.1421C15.9742 21.8765 15.9209 21.6 15.7711 21.3735L12.6908 16.6794C12.5389 16.4578 12.3057 16.3046 12.0414 16.2527C11.7772 16.2008 11.503 16.2544 11.278 16.402C11.0531 16.5496 10.8954 16.7793 10.8389 17.0416C10.7824 17.304 10.8317 17.5779 10.9761 17.8044L12.6908 20.3969C6.18627 18.7913 2.05353 16.3828 2.05353 14.1278C2.05353 11.341 6.2117 7.08845 17.6037 6.00952C17.7385 5.99676 17.8695 5.95767 17.9892 5.89449C18.1088 5.83131 18.2149 5.74527 18.3011 5.64128C18.3874 5.53729 18.4523 5.4174 18.4921 5.28844C18.5318 5.15948 18.5457 5.02398 18.5329 4.88968C18.5201 4.75537 18.4808 4.6249 18.4174 4.50571C18.354 4.38651 18.2676 4.28093 18.1632 4.19498C18.0588 4.10904 17.9384 4.04442 17.8089 4.00481C17.6795 3.96521 17.5434 3.95139 17.4086 3.96415C5.89854 5.05842 0 9.45925 0 14.1278C0 17.5691 4.36889 20.4889 12.3212 22.3911Z"
					fill="white"
				/>
				<path
					d="M51.8023 24.0953C61.4683 22.3619 64.3126 18.9359 64.3126 14.9186C64.3126 11.5181 60.0767 8.5561 52.614 6.67488L55.2218 4.88032C55.331 4.80777 55.4253 4.71321 55.4993 4.60214C55.5732 4.49107 55.6252 4.36573 55.6523 4.23342C55.6795 4.1011 55.6811 3.96446 55.6573 3.83146C55.6334 3.69846 55.5844 3.57177 55.5133 3.45876C55.4421 3.34575 55.3501 3.24869 55.2427 3.17323C55.1353 3.09777 55.0146 3.04543 54.8877 3.01926C54.7607 2.99308 54.6301 2.9936 54.5033 3.02077C54.3766 3.04795 54.2563 3.10124 54.1494 3.17754L49.6893 6.25173C49.4735 6.40049 49.3229 6.63283 49.2708 6.89765C49.2187 7.16248 49.2693 7.43811 49.4115 7.66392L52.3361 12.3491C52.4804 12.57 52.7018 12.7228 52.9527 12.7746C53.2036 12.8263 53.464 12.7729 53.6775 12.6257C53.8911 12.4786 54.0409 12.2495 54.0945 11.988C54.1481 11.7264 54.1013 11.4533 53.9642 11.2275L52.3849 8.70904C58.5072 10.2997 62.3628 12.6601 62.3628 14.9186C62.3628 17.1771 60.9662 20.3838 51.4806 22.056C51.3526 22.0781 51.2299 22.1264 51.1198 22.198C51.0096 22.2697 50.9139 22.3633 50.8383 22.4736C50.7628 22.5839 50.7087 22.7087 50.6792 22.8409C50.6497 22.973 50.6454 23.11 50.6665 23.2439C50.6877 23.3778 50.7338 23.506 50.8023 23.6213C50.8708 23.7365 50.9604 23.8365 51.0658 23.9156C51.1713 23.9947 51.2906 24.0512 51.417 24.082C51.5433 24.1129 51.6743 24.1174 51.8023 24.0953Z"
					fill="white"
				/>
				<path
					d="M25.317 10.957C26.6777 11.2343 27.358 11.8843 27.358 12.907C27.358 13.3317 27.2063 13.713 26.903 14.051C26.5997 14.3803 26.1837 14.6403 25.655 14.831C25.135 15.0217 24.55 15.117 23.9 15.117C23.1113 15.117 22.4267 15.0087 21.846 14.792C21.2653 14.5667 20.7323 14.285 20.247 13.947L20.871 12.751C21.2783 13.0457 21.7463 13.2883 22.275 13.479C22.8037 13.661 23.3497 13.752 23.913 13.752C24.433 13.752 24.8533 13.661 25.174 13.479C25.5033 13.2883 25.668 13.0413 25.668 12.738C25.668 12.374 25.447 12.101 25.005 11.919C24.5717 11.7283 23.8653 11.633 22.886 11.633H21.794V10.398H22.886C23.692 10.398 24.303 10.2897 24.719 10.073C25.135 9.85633 25.343 9.56167 25.343 9.189C25.343 8.88567 25.2 8.63433 24.914 8.435C24.6367 8.227 24.2727 8.123 23.822 8.123C22.9293 8.123 22.0367 8.50867 21.144 9.28L20.325 8.188C20.7843 7.78067 21.326 7.44267 21.95 7.174C22.574 6.89667 23.224 6.758 23.9 6.758C24.4893 6.758 25.0223 6.849 25.499 7.031C25.9757 7.20433 26.3527 7.46433 26.63 7.811C26.9073 8.15767 27.046 8.565 27.046 9.033C27.046 9.46633 26.89 9.84767 26.578 10.177C26.266 10.5063 25.8457 10.7663 25.317 10.957ZM32.4997 9.748C33.0284 9.748 33.5267 9.84767 33.9947 10.047C34.4627 10.2377 34.8397 10.528 35.1257 10.918C35.4117 11.308 35.5547 11.7803 35.5547 12.335C35.5547 12.8723 35.4074 13.3577 35.1127 13.791C34.818 14.2157 34.415 14.5537 33.9037 14.805C33.3924 15.0477 32.829 15.169 32.2137 15.169C31.503 15.169 30.853 15.0087 30.2637 14.688C29.6744 14.3587 29.2064 13.8993 28.8597 13.31C28.5217 12.7207 28.3527 12.0447 28.3527 11.282C28.3527 10.4413 28.5347 9.67867 28.8987 8.994C29.2627 8.30067 29.7784 7.75467 30.4457 7.356C31.113 6.95733 31.88 6.758 32.7467 6.758C33.2927 6.758 33.7737 6.823 34.1897 6.953C34.6057 7.07433 35.0087 7.239 35.3987 7.447L34.8787 8.721C34.22 8.32233 33.5354 8.123 32.8247 8.123C32.14 8.123 31.5464 8.331 31.0437 8.747C30.5497 9.15433 30.2247 9.709 30.0687 10.411C30.476 10.1943 30.8704 10.0297 31.2517 9.917C31.633 9.80433 32.049 9.748 32.4997 9.748ZM33.9297 12.361C33.9297 11.9537 33.7694 11.633 33.4487 11.399C33.128 11.165 32.7207 11.048 32.2267 11.048C31.49 11.048 30.749 11.204 30.0037 11.516C30.047 11.9753 30.177 12.3783 30.3937 12.725C30.6104 13.0717 30.8834 13.3403 31.2127 13.531C31.542 13.713 31.893 13.804 32.2657 13.804C32.751 13.804 33.1497 13.674 33.4617 13.414C33.7737 13.1453 33.9297 12.7943 33.9297 12.361ZM40.5975 15.169C39.9128 15.169 39.2585 15.0087 38.6345 14.688C38.0105 14.3587 37.5035 13.8777 37.1135 13.245C36.7235 12.6123 36.5285 11.854 36.5285 10.97C36.5285 10.086 36.7235 9.32767 37.1135 8.695C37.5035 8.06233 38.0105 7.58133 38.6345 7.252C39.2585 6.92267 39.9128 6.758 40.5975 6.758C41.2822 6.758 41.9365 6.92267 42.5605 7.252C43.1845 7.58133 43.6915 8.06233 44.0815 8.695C44.4802 9.32767 44.6795 10.086 44.6795 10.97C44.6795 11.8453 44.4802 12.6037 44.0815 13.245C43.6915 13.8777 43.1845 14.3587 42.5605 14.688C41.9365 15.0087 41.2822 15.169 40.5975 15.169ZM40.5975 13.882C41.0395 13.882 41.4382 13.7607 41.7935 13.518C42.1575 13.2753 42.4392 12.933 42.6385 12.491C42.8465 12.049 42.9505 11.542 42.9505 10.97C42.9505 10.3893 42.8465 9.878 42.6385 9.436C42.4392 8.994 42.1618 8.65167 41.8065 8.409C41.4512 8.16633 41.0482 8.045 40.5975 8.045C40.1555 8.045 39.7568 8.16633 39.4015 8.409C39.0462 8.65167 38.7645 8.994 38.5565 9.436C38.3572 9.878 38.2575 10.3893 38.2575 10.97C38.2575 11.542 38.3572 12.049 38.5565 12.491C38.7645 12.933 39.0462 13.2753 39.4015 13.518C39.7568 13.7607 40.1555 13.882 40.5975 13.882Z"
					fill="white"
				/>
			</svg>
			<div class="text">
				{{ $t("landingPage.clickAndDragToMovePrompt") }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Three60InteractionPopup",
	components: {},
	props: {},
	data: () => ({}),
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	destroyed() {},
};
</script>

<style lang="scss" scoped>
.three60-interaction-popup {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	// background: rgba(0, 0, 0, 0.5);
	cursor: pointer;

	.popup-body {
		position: relative;
		width: 16rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 1.5rem;
		.close-button {
			position: absolute;
			top: 1rem;
			right: 2rem;
		}
		.background-svg {
			height: 100%;
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
		}

		.three60-svg {
			width: 8rem;
			height: 5.375rem;
		}

		.text {
			color: color(secondary-white);
			text-align: center;
			font-size: 1rem;
			font-style: normal;
			font-weight: 700;
			line-height: 1;
			margin-top: 0.375rem;
			max-width: 65%;
		}
	}
}
</style>
